// extracted by mini-css-extract-plugin
module.exports = {"warning__wrapper":"warnings_warning__wrapper__3N_hQ","error":"warnings_error__1yimb"};